module.exports = __webpack_public_path__ + "static/images/manage-class.7c576745031986a1ef9faf8ad9d01784.svg";